import React from "react";
import { Switch, Route } from "react-router-dom";

import { Row } from "antd";

import CustomerDetail from "./CustomerDetail";
import SearchUser from "./SearchUser";

const MergeUpdateCards = ({ ...props }) => {
	const path = "/merge-update-cards";
	return (
		<Row
			style={{
				width: "100%",
				padding: "40px 25px 70px",
				margin: "60px auto 20px",
				backgroundColor: "#FAFAFA",
			}}
			gutter={[12, 48]}>
			<Switch>
				<Route path={`${path}/:userType/:country_code/:customerID`} component={CustomerDetail} />
				<Route exact path={`/`} component={SearchUser} />
				<Route exact path={`${path}`} component={SearchUser} />
				<Route path="*" component={() => <>404 NOT iuiu FOUND</>}></Route>
			</Switch>
		</Row>
	);
};

export default MergeUpdateCards;
